// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3Mb3Z","name":"ConsentHeader_name__2NOo7","birthday":"ConsentHeader_birthday__cISbw","skeleton":"ConsentHeader_skeleton__7AN7h"};